import useAuthUser from "@/composables/useAuthUser";
import { RouteRecordRaw } from "vue-router";
import EditPage from "../pages/EditPage.vue";
import IndexPage from "../pages/IndexPage.vue";

export default {
  path: "/internal/roles",
  children: [
    {
      path: "",
      name: "roles.internal.index",
      component: IndexPage,
      beforeEnter: (to, from, next) => {
        const { user } = useAuthUser();

        if (!user.value?.internal) {
          return next({
            name: "roles.index",
          });
        } else {
          next();
        }
      },
    },
    {
      path: ":id",
      name: "roles.edit.internal",
      component: EditPage,
      beforeEnter: (to, from, next) => {
        const { user } = useAuthUser();

        if (!user.value?.internal) {
          return next({
            name: "roles.edit",
            params: {
              id: to.params.id,
            },
          });
        } else {
          return next();
        }
      },
    },
  ],
} as RouteRecordRaw;
